import React from 'react';

import { useState } from 'react';
import { useEffect } from 'react';
import {
    getallhotels, getregions
} from "../dbconnector/connector";



const RegionSelection = ({ isDisabled, data, valueneeded }) => {

    useEffect(() => {
        LoadRegions();
    }, [data]);


    const LoadRegions = () => {
        getregions().then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    buildcombo(body)
                })
            } else {
                //setErrorMessage(res.statusText)
            }
        })

    }
    const buildcombo = (regions) => {

        try {

            if (regions.length > 0) {

                let listForRegions = document.getElementById("RegionList");
                if (listForRegions === null) {
                    listForRegions = document.createElement("select");
                    listForRegions.id = "RegionList";

                } else {
                    listForRegions.innerHTML = ""
                }
                regions.forEach((region, index) => {
                    const regionOption = document.createElement("option");
                    regionOption.value = region.id;

                    regionOption.innerText = region.description
                    listForRegions.appendChild(regionOption)
                });
                //console.log("dddddd = ",data.selectedregion)
                listForRegions.value = data.selectedregion
            } else {
                //setErrorMessage("Error while retrieving hotels")
            }
        } catch (error) {
            //setErrorMessage("Error while retrieving hotels")
        }
    }

    return (
        <select id="RegionList" value={data.selectedhotel} onChange={data.handleitemchange} name={data.fieldname} disabled={isDisabled}>

        </select>
    );
}


export default RegionSelection;
